"use strict";

exports.__esModule = true;

exports.default = function () {
  return function (Component) {
    return Component;
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-hot-loader/lib/prod/hot.prod.js
// module id = 696
// module chunks = 0